export const ANALYTICS_CONSENT_STORAGE_KEY = 's-shot-analytics-consent';
export const ANALYTICS_CONSENT_COOKIE_NAME = 's_shot_analytics_consent';
const ANALYTICS_CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export type AnalyticsConsentDecision = 'accepted' | 'declined';

export function parseAnalyticsConsent(
  value: string | null | undefined,
): AnalyticsConsentDecision | null {
  if (value === 'accepted' || value === 'declined') {
    return value;
  }

  return null;
}

export function buildAnalyticsConsentCookie(
  decision: AnalyticsConsentDecision,
): string {
  return `${ANALYTICS_CONSENT_COOKIE_NAME}=${decision}; Max-Age=${ANALYTICS_CONSENT_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
}
